<template>
  <div id="manageSpecial">
    ManageSpecialManageSpecial
  </div>
</template>

<script>
export default {
  name: 'ManageSpecial'
}
</script>
